import QRCode from 'qrcode'

window.generateQr = function (qrSize) {
  const canvas = document.getElementById('canvas')
  if (canvas.dataset.qrText == '') {
    console.log('no text found')
    alert('Nessun testo valido per il QR Code');
  } else {

    if (!qrSize)
      qrSize = canvas.dataset.size ? parseInt(canvas.dataset.size, 10) : 375

    console.log(`generating QR ${qrSize}x${qrSize}...`)

    QRCode.toCanvas(canvas, 'https://app.codiceforestan.it/dl?qr=' +canvas.dataset.qrText, {
      errorCorrectionLevel: 'M',
      width: qrSize,
      height: qrSize,
      }, function (error) {
      if (error)
        console.error(error)
      else {
        const logoSize = parseInt(canvas.width / 6, 10)
        const offset = parseInt(canvas.width / 2, 10) - (logoSize / 2)
        const logo = new Image();
        logo.src = '/logo_filled.jpg';
        logo.onload = () => {
          const ctx = canvas.getContext('2d');
          ctx.imageSmoothingEnabled = true;
          // This puts a 50x50 logo right at the center of a 200x200 canvas
          ctx.drawImage(logo, offset, offset, logoSize, logoSize);
          console.log('success!');
        }
      }
    })
  }
}

document.addEventListener("DOMContentLoaded", function() {


      // QRCode.toDataURL(canvas.dataset.qrText, { errorCorrectionLevel: 'M' })
      //   .then(url => {
      //     console.log(url)
      //   })
      //   .catch(err => {
      //     console.error(err)
      //   })

      // // With async/await
      // const generateQR = async text => {
      //   try {
      //     console.log(await QRCode.toDataURL(text))
      //   } catch (err) {
      //     console.error(err)
      //   }
      // }
  const canvas = document.getElementById('canvas')
  if (canvas) {
    window.generateQr();
  } else {
    console.log('No canvas found')
  }

})